import API from '../utils/api';
import { gotoLogin } from './redirect';

export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
export const GET_APPOINTMENTS_SUCCESSFUL = 'GET_APPOINTMENTS_SUCCESSFUL';
export const GET_APPOINTMENTS_FAILED = 'GET_APPOINTMENTS_FAILED';

export const POST_APPOINTMENT = 'POST_APPOINTMENT';
export const POST_APPOINTMENT_SUCCESSFUL = 'POST_APPOINTMENT_SUCCESSFUL';
export const POST_APPOINTMENT_FAILED = 'POST_APPOINTMENT_FAILED';

export const PUT_APPOINTMENT = 'PUT_APPOINTMENT';
export const PUT_APPOINTMENT_SUCCESSFUL = 'PUT_APPOINTMENT_SUCCESSFUL';
export const PUT_APPOINTMENT_FAILED = 'PUT_APPOINTMENT_FAILED';

export const OPEN_APPOINTMENT_MODAL = 'OPEN_APPOINTMENT_MODAL';
export const SELECTED_A_DATE = 'SELECTED_A_DATE';
export const UPDATED_APPOINTMENT_STATUS = 'UPDATED_APPOINTMENT_STATUS';

export const RESET_APPOINTMENTS_FLAG = 'RESET_APPOINTMENTS_FLAG';

export const NEW_APPOINTMENT = 'NEW_APPOINTMENT';
export const VIEW_APPOINTMENT = 'VIEW_APPOINTMENT';


export const getAppointments = () => {
    return {
        type: GET_APPOINTMENTS
    }
};

export const getAppointmentsSuccessful = (appointments) => {
    return {
        type: GET_APPOINTMENTS_SUCCESSFUL,
        appointments
    }
};

export const getAppointmentsFailed = () => {
    return {
        type: GET_APPOINTMENTS_FAILED
    }
};

export const postAppointment = () => {
    return {
        type: POST_APPOINTMENT
    }
};

export const postAppointmentSuccess = (appointment) => {
    return {
        type: POST_APPOINTMENT_SUCCESSFUL,
        appointment
    }
};

export const postAppointmentFailed = () => {
    return {
        type: POST_APPOINTMENT_FAILED
    }
};

export const putAppointment = () => {
    return {
        type: PUT_APPOINTMENT
    }
};

export const putAppointmentSuccess = (appointment) => {
    return {
        type: PUT_APPOINTMENT_SUCCESSFUL,
        appointment
    }
};

export const putAppointmentFailed = () => {
    return {
        type: PUT_APPOINTMENT_FAILED
    }
};

export const selectedADate = (data) => {
    return {
        type: SELECTED_A_DATE,
        data: data
    }
};

export const resetAppointmentsFlag = () => {
    return {
        type: RESET_APPOINTMENTS_FLAG
    }
};

export const newAppointment = () => {
    return {
        type: NEW_APPOINTMENT
    }
};

export const viewAppointment = (appointment) => {
    return {
        type: VIEW_APPOINTMENT,
        appointment
    }
};

export const postAppointmentApi = (payload) => (dispatch) => {
    dispatch(postAppointment());

    return API.post('dental/appointments', payload).then((res) => {
        if (res.status !== 201) {
            dispatch(postAppointmentFailed());
            return;
        }

        res.json().then((json) => {
            dispatch(postAppointmentSuccess(json.data));
        });
    })
};

export const putAppointmentApi = (payload, appointmentId) => (dispatch) => {
    dispatch(putAppointment());

    return API.put(`dental/appointments/${appointmentId}`, payload).then((res) => {
        if (res.status !== 201) {
            dispatch(putAppointmentFailed());
            return;
        }

        res.json().then((json) => {
            dispatch(putAppointmentSuccess(json.data));
        });
    })
};

export const getAppointmentsApi = (filters) => (dispatch) => {
    dispatch(getAppointments());

    let url = `dental/appointments`;
    if (filters) {
        url = `dental/appointments${filters}`;
    }

    return API.get(url).then((res) => {
        if (res.status === 401) {
            dispatch(getAppointmentsFailed());
            dispatch(gotoLogin());
            return;
        }

        if (res.status !== 200) {
            dispatch(getAppointmentsFailed());
            return;
        }

        res.json().then((json) => {
            dispatch(getAppointmentsSuccessful(json.data));
        });
    })
};


/** WEBPACK FOOTER **
 ** ./src/actions/appointments.js
 **/